
import React from "react";
import { Routes, Route, } from "react-router-dom";  
import { RouteConstant } from "./RouteConstant";
import PageLayout from "../screens/Layout";
import UserList from "../screens/User/UserList";

const HRRoutes = () => {
  return (
    <Routes>
        <Route path={RouteConstant.ROOT} element={<PageLayout />}>
            <Route path={RouteConstant.USERS} element={<UserList />} />
        </Route>
    </Routes>
  );
}

export default HRRoutes;